import React from 'react';
import { Box } from '@/shared/ui/box';
import { Button } from '@/shared/ui/form/button';
import {
  BodyTextRegularSecondary,
  BodyTextBoldPrimary,
} from '@/shared/ui/typography';
import { Timer } from '@/shared/ui/timer';

import { useAuth } from '@/features/auth-managment/model/auth-context';
import {
  FormWrapper,
  SpinnerBox,
  CircleBorder,
  CircleCore,
  CircleImage,
  AuthCloseIconImage,
  ConfirmationPhoneText,
  FormContainer,
} from '@/features/auth-managment/styles';

export const EmailConfirmation = () => {
  const {
    currentEmail,
    handleClose,
    t,
    handleEmailResend,
    handleResetPassword,
    currentStep,
    user,
  } = useAuth();

  return (
    <FormWrapper $currentStep={currentStep}>
      <FormContainer>
        <Box onClick={handleClose}>
          <AuthCloseIconImage
            width={32}
            height={32}
            src="/images/icons/close-dialog.svg"
          />
        </Box>

        <SpinnerBox>
          <CircleBorder>
            <CircleCore />
          </CircleBorder>
          <CircleImage
            width={56}
            height={56}
            src={'/images/background/email-spin.svg'}
          />
        </SpinnerBox>
        <Box $paddingTop={16} $paddingBottom={16} $textAlign="center">
          <BodyTextRegularSecondary color="#AFAFAF">
            {t('auth.email.desc')}
          </BodyTextRegularSecondary>
        </Box>
        <ConfirmationPhoneText>
          <BodyTextBoldPrimary>
            {user?.email || currentEmail}
          </BodyTextBoldPrimary>
        </ConfirmationPhoneText>

        <Box
          $display="flex"
          $justifyContent="center"
          $alignItems="center"
          $gap={8}
        >
          <Box $cursor="pointer" onClick={handleResetPassword}>
            <BodyTextRegularSecondary color="#AFAFAF">
              {t('auth.email.resend_question')}
            </BodyTextRegularSecondary>
          </Box>

          <Timer
            handleResend={handleEmailResend}
            triggerSlot={
              <Button variant="orangeGradient">{t('auth.email.resend')}</Button>
            }
          />
        </Box>
      </FormContainer>
    </FormWrapper>
  );
};
